import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Chip from '@mui/material/Chip';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setSelectedCycle } from 'redux/selectedCycle';
import CycleCodeService from 'services/CycleCodeService';
import { checkPondTypeLabel } from 'utils';
import { POND_STATUS_CYCLE } from 'utils/consts';
import Table from '../../components/Table';
import api from '../../services/api';
import { useRef } from "react";

function Cycles() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const [cycles, setCycles] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const location = useLocation();
  const id = location?.state?.id;
  const pond = location?.state?.pond;
  const searchText = location?.state?.searchText ?? '';
  const [user, setUser] = useState(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const dispatch = useDispatch();

  const updatedRef = useRef(false);

  useEffect(() => {
    async function ini() {
      setUser(await api.get('users'));
    }
    ini();
  }, []);

  useEffect(() => {
    if (user?.data.firstAccess === true) setDialogIsOpen(true);
  }, [user]);

  function handleStatus(_rowData) {
    if (_rowData.status === POND_STATUS_CYCLE.CULTIVANDO) {
      return (
        <Chip
          style={{
            backgroundColor: '#FFBB01',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }

    if (_rowData.status === POND_STATUS_CYCLE.CONCLUIDO) {
      return (
        <Chip
          style={{
            backgroundColor: '#0B8846',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }

    if (_rowData.status === POND_STATUS_CYCLE.PREPARANDO) {
      return (
        <Chip
          style={{
            backgroundColor: '#0D88FF',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }

    if (
      _rowData.status !== POND_STATUS_CYCLE.CULTIVANDO &&
      _rowData.status !== POND_STATUS_CYCLE.CONCLUIDO &&
      _rowData.status !== POND_STATUS_CYCLE.PREPARANDO
    ) {
      return (
        <Chip
          style={{
            backgroundColor: '#f44336',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }
  }

  const columns = [
    {
      title: 'Viveiros',
      field: 'pond.description',
      type: 'string',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Status',
      field: 'status',
      editable: 'never',
      render: (rowData) => handleStatus(rowData),

      hideFilterIcon: true,
    },
    {
      title: 'Data de início',
      field: 'begin',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) =>
        rowData.begin != null ? (
          <p>{moment(rowData.begin.substring(0, 10)).format('DD/MM/YYYY')}</p>
        ) : (
          <p>Ainda não iniciado</p>
        ),
    },
    {
      title: 'Data de conclusão',
      field: 'end',
      type: 'date',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) =>
        rowData.end != null ? (
          <span>
            {moment(rowData.end.substring(0, 10)).format('DD/MM/YYYY')}
          </span>
        ) : (
          <span>Ainda não concluído</span>
        ),
    },
    {
      title: 'População Atual',
      field: 'population',
      editable: 'never',
      render: (rowData) => (
        <>{new Intl.NumberFormat('pt-BR').format(rowData.population)}</>
      ),
      hideFilterIcon: true,
    },
    {
      title: 'Densidade',
      field: 'density',
      render: (rowData) =>
        `${new Intl.NumberFormat('pt-BR').format(
          rowData.density
        )} Animais/${checkPondTypeLabel(rowData.pond.type)}`,
      hideFilterIcon: true,
    },
  ];

useEffect(() => {
  if (!selectedCycle || !selectedCycle.id || updatedRef.current) return;

  async function updateSelectedCycle() {
    try {
      const updatedCurrentCycle = await CycleCodeService.currentCycleById(
        selectedCycle.id
      );
      dispatch(setSelectedCycle(updatedCurrentCycle));
      updatedRef.current = true; // evita loop
    } catch (error) {
      console.error('Erro ao atualizar ciclo selecionado:', error);
    }
  }

  updateSelectedCycle();
}, [selectedCycle?.id, dispatch]);

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get(
          `/cycles/cycle-code/${selectedCycle.id}`,
          {
            params: id ? { cycle: id } : {},
          }
        );
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const { data } = response;
          const organizedData = data.map((cycle) => ({
            id: cycle.id,
            pond: cycle.pond,
            cycleCode: cycle.cycleCode,
            begin:
              cycle.begin === null
                ? 'Ainda não iniciado'
                : moment(cycle.begin).format('DD/MM/YYYY'),
            end:
              cycle.end === null
                ? 'Ainda não concluído'
                : moment(cycle.end).format('DD/MM/YYYY'),
            population: cycle.population,
            description: cycle.pond.description,
            status: cycle.status,
            observation: cycle.observation,
            density: cycle.density,
          }));
          setExportData(organizedData);
          setCycles(data);
          setOpenProgress(true);
        }
      } catch (err) {}
    }
    loadData();
  }, [openProgress, selectedCycle]);

  function setData(newData) {
    const tempData = [];
    cycles.map((cycle) =>
      cycle.id === newData.id ? tempData.push(newData) : tempData.push(cycle)
    );
    setCycles(tempData);
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function CustomTitle() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            fontFamily: 'Roboto',
            marginInlineEnd: '10px',
          }}
        >
          Viveiros por Ciclo
        </div>
        {pond ? (
          <div
            style={{
              padding: '5px',
              marginLeft: 'auto',
              border: '1px solid black',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            {pond.description}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <>
      <Dialog open={dialogIsOpen} fullWidth>
        <DialogTitle>
          Ultimo passo para poder iniciar a usar o sistema
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            No canto inferior direito da sua tela, clique no mais para cadastrar
            seu viveiro nesse ciclo
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogIsOpen(false)}>ok</Button>
        </DialogActions>
      </Dialog>

      <Table
        title="Viveiros por Ciclo"
        titleCustomized={<CustomTitle />}
        route="/cycles/"
        routeAdd="/cycle/"
        columns={columns}
        data={cycles}
        setData={setData}
        dataLoaded={openProgress}
        copy={false}
        exportData={exportData}
        searchText={searchText}
      />
    </>
  );
}

export default Cycles;
